interface Medias {
  small: MediaQueryList
  medium: MediaQueryList
  large: MediaQueryList
  ultra: MediaQueryList
  max: MediaQueryList
  headerMetanavSticky: MediaQueryList
}

const medias: Medias = {
  small: window.matchMedia('(min-width: 600px)'),
  medium: window.matchMedia('(min-width: 900px)'),
  large: window.matchMedia('(min-width: 1260px)'),
  ultra: window.matchMedia('(min-width: 1600px)'),
  max: window.matchMedia('(min-width: 1920px)'),
  headerMetanavSticky: window.matchMedia('(min-height: 580px)'),
};

export const media = (media: string): MediaQueryList => {
  return medias[media];
}

export const addMediaChangeListener = (callback: EventListenerOrEventListenerObject) => {
  Object.keys(medias).forEach((m) => {
    media(m).addEventListener('change', callback);
  })
}

export const removeMediaChangeListener = (callback: EventListenerOrEventListenerObject) => {
  Object.keys(medias).forEach((m) => {
    media(m).removeEventListener('change', callback);
  })
}
